var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',[_c('IconCompass'),_c('div',{staticClass:"spanShortcut"},[_vm._v("Start")]),_c('a',{staticClass:"linkShortcut",on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }